import { writable } from 'svelte/store';

export const isMobile = writable(false);
export const openNavState = writable(false);
export const navigation = writable();
